import { createContext } from "react";

const LocationHistoryContext = createContext();

export default LocationHistoryContext;
